/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createArrayOfLength(length, fillWith) {
    var array = [];
    /* eslint-disable */
    for (var i = 0; i < length; i++) {
        array.push(fillWith);
    }
    /* eslint-enable */
    return array;
}
exports.createArrayOfLength = createArrayOfLength;